import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../auth/useAuth";

interface GuestRouteProps {
  children: ReactNode;
}

export default function GuestRoute({ children }: GuestRouteProps) {
  const { data } = useAuth();
  const isLoggedIn = !!data?.user;

  if (isLoggedIn) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
